import React from "react";
import { useAppConfig } from "../../api/useAppConfig";

const AppVersion = () => {
  const { config, loading, error } = useAppConfig();

  if (loading || error || !config?.version) return null;

  return (
    <div
      style={{
        fontSize: 12,
        color: "#999",
        textAlign: "center"
      }}
    >
      Version {config.version}
    </div>
  );
};

export default AppVersion;
